import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RhdRoot } from '../../design';
import { useRhdTheme } from '../../design/theme';
import './marketing-tokens.css';
import './marketing.css';
import { Footer } from './Footer';
import { Nav } from './Nav';
export { readTheme } from '../../design/theme';
/** Shell for every logged-out marketing page: scoped design tokens, theme, nav and footer. */ export function MarketingLayout({ children, testid }) {
    const { theme, dark, toggleTheme } = useRhdTheme();
    return /*#__PURE__*/ _jsxs(RhdRoot, {
        theme: theme ?? undefined,
        className: "mk-site",
        "data-testid": testid,
        children: [
            /*#__PURE__*/ _jsx(Nav, {
                dark: dark,
                onToggleTheme: toggleTheme
            }),
            children,
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
}
